import React from 'react';
import { Box } from '@mui/material';
import { CssTextField } from 'components/select';
import { requestDetails } from 'pages/onboard-developers/store';
import { useRecoilValue } from 'recoil';

const Email = () => {
    const details = useRecoilValue(requestDetails);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <CssTextField
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                autoComplete="off"
                label="Email *"
                value={details?.email || ''}
                disabled
            />
        </Box>
    );
};

export default Email;
